var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_381_727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8323 10.0164L19.6199 2.22853C20.1267 1.72196 20.1267 0.90291 19.6199 0.396343C19.1133 -0.110223 18.2943 -0.110223 17.7877 0.396343L9.99989 8.18418L2.21228 0.396343C1.70548 -0.110223 0.88667 -0.110223 0.380103 0.396343C-0.126701 0.90291 -0.126701 1.72196 0.380103 2.22853L8.16771 10.0164L0.380103 17.8042C-0.126701 18.3108 -0.126701 19.1298 0.380103 19.6364C0.632556 19.8891 0.964494 20.016 1.29619 20.016C1.62789 20.016 1.95959 19.8891 2.21228 19.6364L9.99989 11.8485L17.7877 19.6364C18.0404 19.8891 18.3721 20.016 18.7038 20.016C19.0355 20.016 19.3672 19.8891 19.6199 19.6364C20.1267 19.1298 20.1267 18.3108 19.6199 17.8042L11.8323 10.0164Z",
    fill: "#202047"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_381_727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMenuIcon);
export default __webpack_public_path__ + "static/media/closeMenuIcon.9ea1ee6a3159f653ad81e11ce223d92a.svg";
export { ForwardRef as ReactComponent };